import React, {useEffect, useState} from 'react';
import styles from './TrialExpirationBanner.module.css';
import {dashboardText} from '../../pages/Workspace/dashboardText';
import {useNavigate} from 'react-router-dom';

interface Props {
  expirationDate?: string;
  organizationId?: string;
}

export const expiredText = 'Expired';

export const getTimeLeft = (dateStr?: string): string => {
  if (!dateStr) return '';

  const targetDate = new Date(dateStr);
  const now = new Date();

  const diffMs = targetDate.getTime() - now.getTime();

  if (diffMs <= 0) {
    return expiredText;
  }
  // ----------------------
  // Trial expiration logic:
  //
  // Let's say expiration = Jan 8, 00:00
  //
  // - Jan 1 (any time): show "7 days"
  // - Jan 6 (any time): show "2 days"
  // - Jan 7:
  //     - 22:30 → show "2 hours"
  //     - 23:30 → show "1 hour"
  // - Jan 8, 00:00 and after → show "expired"
  //
  // Rule:
  // - If the current date is strictly before expiration date
  //   and there is ≥ 1 full day left (midnight-to-midnight): show days
  // - If same calendar day: show hours
  // ----------------------
  const targetDayStart = new Date(targetDate);
  targetDayStart.setHours(0, 0, 0, 0);

  const todayStart = new Date(now);
  todayStart.setHours(0, 0, 0, 0);

  const diffDays = Math.ceil(
    (targetDayStart.getTime() - todayStart.getTime()) / (1000 * 60 * 60 * 24),
  );

  if (diffDays >= 1) {
    return `${diffDays} ${dashboardText.day}${diffDays > 1 ? 's' : ''}`;
  }

  const diffHours = Math.ceil(diffMs / (1000 * 60 * 60));
  return `${diffHours} ${dashboardText.hour}${diffHours > 1 ? 's' : ''}`;
};

const TrialExpirationBanner = ({expirationDate, organizationId}: Props) => {
  const [expireText, setExpireText] = useState('');
  const navigate = useNavigate();
  useEffect(() => {
    setExpireText(getTimeLeft(expirationDate));
  });

  const onUpgrade = () => {
    navigate(`/manage/${organizationId}/settings/subscription`);
  };

  return expireText == '' || closed ? null : (
    <div className={styles.banner}>
      {expireText === expiredText ? (
        <span>
          {dashboardText.subcriptionEnded}.&nbsp;{dashboardText.check}
        </span>
      ) : (
        <span>{dashboardText.trialBannerText(expireText)}</span>
      )}
      <button className={styles.renewButton} onClick={onUpgrade}>
        {dashboardText.trialBannerButton}
      </button>
    </div>
  );
};

export default TrialExpirationBanner;
